import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import {
  addIcon,
  eyeIcon,
  filterIcon,
  refreshIcon,
  searchIcon,
} from "../../assets/icons/SvgIconList";

interface IAdvanceSearch {
  customButtonIcon?: JSX.Element;
  customButtonText?: string;
  handleCustomButtonOnClick?: () => void;
  handleOnClickAdd?: () => void;
  handleSearchChange?: (text: string) => void;
  searchText?: string;
  handleDeleteCheckBox?: (check: boolean) => void;
  handleCheckBox?: () => void;
  filterCheckBox?: boolean;
  filterNode?: React.ReactNode;
  refreshTable?: () => void;
}

const AdvanceSearch = ({
  customButtonIcon,
  customButtonText,
  handleCustomButtonOnClick,
  handleOnClickAdd,
  handleSearchChange,
  searchText,
  handleDeleteCheckBox,
  handleCheckBox,
  filterCheckBox,
  filterNode,
  refreshTable,
}: IAdvanceSearch) => {
  const { t } = UseTranslationHook();
  const location = useLocation();
  const [showFilter, setShowFilter] = useState(false);

  const slugHeading = location.pathname.replace("/admin/", "");
  let normalString = slugHeading.replace(/-/g, " ");
  let heading = normalString.replace(/\b\w/g, function (char) {
    return char.toUpperCase();
  });

  return (
    <div>
      <div className="min-w-max w-full  bg-skin-advance-search-background-color flex py-2 px-6 ps-3 rounded-t-sm">
        <div className="text-skin-advance-search-text-label-color  text-lg font-semibold me-auto flex items-center">
          {heading ? heading : "Service Category"}
        </div>
        {handleCustomButtonOnClick && (
          <button
            type="button"
            onClick={handleCustomButtonOnClick}
            className="flex ml-2 items-center h-9 px-3 py-2  text-xs font-medium text-center text-skin-advance-search-text-color border rounded  focus:outline-none bg-skin-primary-btn"
          >
            {customButtonIcon && customButtonIcon}
            &nbsp;{customButtonText && t(customButtonText)}
          </button>
        )}
        {handleDeleteCheckBox && (
          <div className="checkbox-wrapper m-2">
            <label className="flex items-center">
              <input
                type="checkbox"
                name="is_premium"
                className="h-4 w-4 mr-2 rounded-md"
                checked={filterCheckBox}
                onChange={(e) => handleDeleteCheckBox(e.target.checked)}
              />
              <span className="text-lg">{t("show_deleted")}</span>
            </label>
          </div>
        )}
        {handleCheckBox && (
          <div className="checkbox-wrapper m-2">
            <label className="flex items-center">
              <div
                className="cursor-pointer w-5 h-5 mr-2"
                onClick={handleCheckBox}
              >
                {eyeIcon}
              </div>
              <span className="text-lg cursor-pointer" onClick={handleCheckBox}>
                {t("show_all_subscriptions")}
              </span>
            </label>
          </div>
        )}
        {refreshTable && (
          <div className="w-8  m-1 cursor-pointer" onClick={refreshTable}>
            {refreshIcon}
          </div>
        )}

        {filterNode && (
          <button
            type="button"
            onClick={() => setShowFilter((prev) => !prev)}
            className=" flex items-center px-3 py-2 text-xs font-medium text-center  bg-skin-advance-search-btn-color rounded focus:outline-none mx-3"
          >
            <div className="text-skin-search-icon-color">{filterIcon}</div>
            &nbsp;{t("filter")}
          </button>
        )}
        {handleSearchChange && (
          <div>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <div className="w-4 h-4 text-skin-search-icon-color">
                  {searchIcon}
                </div>
              </div>
              <input
                type="search"
                id="default-search"
                className="block w-auto p-2 pl-10  text-sm  rounded"
                placeholder="Search Data"
                onChange={(event) => handleSearchChange(event.target.value)}
                value={searchText}
                required
              />
            </div>
          </div>
        )}

        {handleOnClickAdd && (
          <button
            type="button"
            onClick={handleOnClickAdd}
            className=" flex ml-2 items-center h-9 px-3 py-2  text-xs font-medium text-center text-skin-advance-search-text-color border rounded  focus:outline-none bg-skin-primary-btn"
          >
            {addIcon}
            &nbsp;{t("add_data")}
          </button>
        )}
      </div>
      {showFilter && filterNode && (
        <div className="min-w-max w-full flex py-2 px-6 ps-3 rounded-t-sm">
          {filterNode}
        </div>
      )}
    </div>
  );
};

export default AdvanceSearch;
